import type { Options } from 'highcharts';

export const CHART_INSTITUTIONS_COLORS = [
  '#E9752F',
  '#195AB4',
  '#2066AE',
  '#002820',
  '#FFB01C',
];

export const getChartInstitutionColor = (index: number, colors?: string[]) => {
  const CUSTOM_COLORS =
    colors && colors.length > 0 ? colors : CHART_INSTITUTIONS_COLORS;
  const numberOfColors = CUSTOM_COLORS.length;
  if (index < numberOfColors - 1) {
    return CUSTOM_COLORS[index];
  }
  const correctedIndex = index % numberOfColors;
  return CUSTOM_COLORS[correctedIndex];
};

export const chartOptions: Options = {
  title: {
    text: '',
  },
  chart: {
    backgroundColor: 'transparent',
    height: 190,
    width: 190,
    spacing: [0, 0, 0, 0],
  },
  exporting: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      borderRadius: 0,
      borderWidth: 0,
      innerSize: '63%',
      size: '190px',
      showInLegend: true,
      startAngle: 180,
    },
    series: {
      dataLabels: {
        enabled: false,
      },
    },
  },
};
